module.exports = __webpack_public_path__ + "img/LocationPointActive.f7eb5f7.svg";